export default class RefreshToken {
  /**
   * @type {number}
   */
  userId;

  /**
   * @type {number}
   */
  expiration;

  /**
   *
   * @type {string}
   */
  token;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.userId != null) {
        this.userId = opts.userId;
      }
      if (opts.expiration != null) {
        this.expiration = opts.expiration;
      }
      if (opts.token != null) {
        this.token = opts.token;
      }
    }
  }

  isExpired() {
    return (Date.now() / 1000) > this.expiration;
  }
}
